import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-primary/20 bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-163" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-164" data-mp="2vp6c4b7o0i88">
        <div className="text-center" data-id="element-165" data-mp="39hcsnyeqcr87">
          <SectionHeading id="problem-title" data-id="element-166" data-mp="39gb4cs8pe88j">Does This Sound Familiar?</SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-167" data-mp="35fiv3yzu03c9">
            You're working with lithium and critical mineral projects but struggle with gaps in technical understanding.
            When colleagues ask about lithium geology, extraction efficiency, refining processes, battery materials, or
            project economics, you can't confidently explain the technical reasons.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-primary/30 bg-surface p-6 shadow-glow sm:p-8" data-id="element-168" data-mp="1k527fuxp81cg">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-foreground" data-id="element-169" data-mp="x4ry4mujas6a">
            <AlertTriangleIcon className="h-5 w-5 text-cta" aria-hidden="true" data-id="element-170" data-mp="1244mxd4yu9bi" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-171" data-mp="171eht8b4jd6q">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-172" data-mp="1c19a9gajsatw">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-primary shadow-[0_0_8px_rgba(0,200,248,0.8)]" aria-hidden="true" data-id="element-173" data-mp="1g346w7hja01c" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-174" data-mp="3htz8jfyf8tfz">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-175" data-mp="3hwtqn0tyq268">
            Stop wasting personal time. You're already experienced. What you need is the right tool.
          </p>
          <p className="mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-176" data-mp="k30etfalik80">
            Build your entire <span className="text-primary" data-id="element-177" data-mp="xyuinjwiije9">critical minerals knowledge</span> today.
          </p>
        </div>
      </div>
    </section>;
}